// extracted by mini-css-extract-plugin
module.exports = {"CreateGist":"CreateTag_CreateGist__1wEHE"};